/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonatsauswertungEmailDto } from '../../models/monatsauswertung-email-dto';

export interface SendMonatsauswertungForMitarbeiter$Params {
  mitarbeiterId: string;
      body?: MonatsauswertungEmailDto
}

export function sendMonatsauswertungForMitarbeiter(http: HttpClient, rootUrl: string, params: SendMonatsauswertungForMitarbeiter$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, sendMonatsauswertungForMitarbeiter.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

sendMonatsauswertungForMitarbeiter.PATH = '/v1/mitarbeiter/{mitarbeiterId}/monatsauswertungen/mail';
